import { computed } from 'vue';

export const useEnv = () => {
  const editableNgayHoanThanhPhieuNhap = computed(
    () => process.env.VUE_APP_ALLOW_UPDATE_NGAY_HOAN_THANH_PHIEU_NHAP === 'true'
  );

  const editableNgayHoanThanhPhieuXuat = computed(
    () => process.env.VUE_APP_ALLOW_UPDATE_NGAY_HOAN_THANH_PHIEU_XUAT === 'true'
  );

  const showHoanThanhBBGT = computed(
    () => process.env.VUE_APP_ALLOW_UPDATE_NGAY_HOAN_THANH_BBGT === 'true'
  );

  const allowUpdateTaiKhoanPhieuXuatKhac = computed(
    () => process.env.VUE_APP_ALLOW_UPDATE_TAI_KHOAN_PHIEU_XUAT_KHAC === 'true'
  );

  const enableInputNgayRaXuong = computed(
    () => process.env.VUE_APP_BBGT_ENABLE_INPUT_NGAY_RA_XUONG === 'true'
  );

  return {
    allowUpdateTaiKhoanPhieuXuatKhac,
    editableNgayHoanThanhPhieuNhap,
    editableNgayHoanThanhPhieuXuat,
    showHoanThanhBBGT,
    enableInputNgayRaXuong,
  };
};
